var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#1E163B;}\n\t.st2{fill:#2A1E51;}\n\t.st3{fill:#332664;}\n\t.st4{fill:#2A276A;}\n\t.st5{fill:#3A3692;}\n\t.st6{fill:#4843B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "746.24,736.97 655.07,687.37 655.17,630.75 746.34,680.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "693.78,744.34 602.61,694.74 655.07,687.37 746.24,736.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "746.26,623.85 655.09,574.25 655.2,517.73 746.37,567.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "693.99,631.2 602.82,581.6 655.09,574.25 746.26,623.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "641.49,751.69 550.31,702.09 550.42,645.56 641.59,695.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "589.19,759.04 498.02,709.44 550.31,702.09 641.49,751.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "746.47,510.71 655.3,461.11 655.41,404.59 746.58,454.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "694.2,518.06 603.03,468.46 655.3,461.11 746.47,510.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "641.7,638.63 550.52,589.04 550.63,532.51 641.8,582.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "589.4,645.98 498.23,596.39 550.52,589.04 641.7,638.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "641.91,525.49 550.73,475.9 550.84,419.37 642.01,468.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "589.61,532.84 498.44,483.25 550.73,475.9 641.91,525.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M550.41,446.6l235.8-33.14l-0.66,353.12l-235.8,33.14L550.41,446.6z M746.24,736.97l0.11-56.62l-52.46,7.37 l-0.11,56.62L746.24,736.97 M641.49,751.69l0.1-56.53l-52.29,7.35l-0.11,56.53L641.49,751.69 M641.7,638.63l0.1-56.53 l-52.29,7.35l-0.1,56.53L641.7,638.63 M641.91,525.49l0.1-56.53l-52.29,7.35l-0.1,56.53L641.91,525.49 M694.3,461.53l-0.1,56.53 l52.28-7.35l0.11-56.53L694.3,461.53 M694.09,574.67l-0.1,56.53l52.28-7.35l0.11-56.53L694.09,574.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "549.75,799.72 458.58,750.13 459.23,397 550.41,446.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "550.41,446.6 459.23,397 695.04,363.86 786.21,413.46  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.22,750.93 405.05,701.33 405.15,644.8 496.32,694.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "443.94,758.28 352.77,708.68 405.05,701.33 496.22,750.93  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.61,637.94 405.43,588.35 405.54,531.73 496.71,581.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "444.15,645.32 352.98,595.72 405.43,588.35 496.61,637.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "391.64,765.71 300.47,716.11 300.58,659.6 391.75,709.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "339.36,773.06 248.19,723.46 300.47,716.11 391.64,765.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.64,524.83 405.47,475.23 405.57,418.71 496.74,468.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "444.36,532.18 353.19,482.58 405.47,475.23 496.64,524.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "391.85,652.67 300.68,603.07 300.79,546.54 391.96,596.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "339.57,660.01 248.4,610.42 300.68,603.07 391.85,652.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496.85,411.69 405.68,362.09 405.78,305.57 496.96,355.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "444.57,419.04 353.4,369.44 405.68,362.09 496.85,411.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "392.06,539.61 300.89,490.02 301,433.49 392.17,483.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "339.78,546.96 248.61,497.36 300.89,490.02 392.06,539.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "392.27,426.47 301.1,376.88 301.21,320.35 392.38,369.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "339.99,433.82 248.82,384.22 301.1,376.88 392.27,426.47  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.92,328.21l261.4-36.74l-0.94,508.72l-261.4,36.74L287.92,328.21z M496.61,637.94l0.11-56.62 l-52.45,7.37l-0.11,56.62L496.61,637.94 M392.06,539.61l0.11-56.53l-52.28,7.35l-0.11,56.53L392.06,539.61 M391.85,652.67 l0.11-56.53l-52.28,7.35l-0.1,56.53L391.85,652.67 M392.27,426.47l0.11-56.53l-52.28,7.35l-0.11,56.53L392.27,426.47  M444.47,475.65l-0.1,56.53l52.28-7.35l0.11-56.53L444.47,475.65 M496.22,750.93l0.11-56.53l-52.28,7.35l-0.1,56.53 L496.22,750.93 M444.68,362.51l-0.1,56.53l52.28-7.35l0.11-56.53L444.68,362.51 M391.64,765.71l0.1-56.52l-52.28,7.35 l-0.1,56.52L391.64,765.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.97,836.93 195.8,787.34 196.74,278.61 287.92,328.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "287.92,328.21 196.74,278.61 458.14,241.88 549.31,291.47  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.2ff1b4459711a8b045617ca4b132db65.svg";
export { ForwardRef as ReactComponent };